import type maplibregl from "maplibre-gl";

// Tiny module-level handle so non-React modules (permalink serializer) can
// read the camera without threading the map instance through the store.
let _map: maplibregl.Map | null = null;

export function setMapHandle(m: maplibregl.Map | null) {
  _map = m;
}

export function getMapHandle(): maplibregl.Map | null {
  return _map;
}
